export const noData = 'No Data Available';
export const nullValue = '-';
export const suffixes = ['', 'k', 'M', 'B', 'T', 'G', 'P', 'E'];
export const defaultLocale = 'en-US';
export const defaultTimeZone = 'America/New_York';
export const calendarCategoryIds = [80974, 80975];
export const calendarTimeZoneId = 385;
